<template>
    <v-dialog v-model="dialog" width="600">
        <v-card>
            <v-card-title class="headline">
                Uzupełnij ceny
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="newForm"
                    v-model="valid"
                    lazy-validation
                    class="dimension--form mt-5 mb-5"
                >
                    <v-row>
                        <v-col cols="12" md="12" align-self="start" dense>
                            <v-checkbox
                                v-model="prices.priceForOrder"
                                class="pt-0"
                                label="Cena za całą usługę"
                            ></v-checkbox>
                          <v-checkbox
                              v-model="prices.undefinedPrice"
                              class="pt-0"
                              label="Nie da się określić ceny"
                          ></v-checkbox>
                            <v-text-field
                                v-model="prices.price"
                                :rules="!prices.undefinedPrice && formRules.price"
                                class="pt-0"
                                label="Cena dla klienta"
                                :disabled="prices.undefinedPrice"
                            >
                                <span
                                    slot="append"
                                >
                                    zł{{ prices.priceForOrder ? '' : '/' + this.order.service.unit}} (netto)
                                </span>
                            </v-text-field>
                            <v-text-field
                                v-model="prices.partnerPrice"
                                :rules="formRules.partnerPrice"
                                class="pt-0"
                                label="Cena partnera"
                            >
                                <span
                                    slot="append"
                                >
                                    zł{{ prices.priceForOrder ? '' : '/' + this.order.service.unit}} (netto)
                                </span>
                            </v-text-field>
                            <v-select
                                class="mt-0 pt-0"
                                v-model="prices.typeForClient"
                                :rules="formRules.typeForClient"
                                label="Typ"
                                :items="typeValues"
                                item-value="value"
                                item-text="text"
                                hide-details
                            ></v-select>
                            <v-select
                                class="mt-2 pt-2"
                                v-model="prices.paymentType"
                                :rules="formRules.paymentType"
                                label="Forma płatności"
                                :items="paymentValues"
                                item-value="value"
                                item-text="text"
                                hide-details
                            ></v-select>
                            <v-textarea v-model="prices.clientNotes" label="Informacja dla klienta"></v-textarea>
                            <v-checkbox
                                v-model="prices.notifyClient"
                                class="pt-0"
                                label="Powiadom klienta o wycenie"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click.prevent="onSubmit"
                            type="Submit"
                            class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                            large
                        >Uzupełnij<v-icon size="24">mdi-send</v-icon>
                        </v-btn
                        >
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
    name: 'ModalSetPrices',
    props: {
        order: {},
    },
    created() {
    },
    data() {
        return {
            dialog: false,
            formRules: {
                price: [(value) => !!value || 'Uzupełnij cenę'],
                type: [(value) => !!value || 'Wybierz typ'],
            },
            valid: false,
            prices: {
                priceForOrder: false,
                undefinedPrice: false,
                typeForClient: '',
                price: '',
                paymentType: '',
                partnerPrice: '',
                clientNotes: '',
                notifyClient: false,
            },
            typeValues: [
                {value: '', text: 'Wybierz typ'},
                {value: 'paidUtilization', text: 'Płatna utylizacja'},
                {value: 'wastePurchase', text: 'Kupno odpadu'},
                {value: 'wasteFree', text: 'Bezpłatny odbiór'},
            ],
            paymentValues: [
                {value: '', text: 'Wybierz formę płatności'},
                {value: 'cash', text: 'Gotówka'},
                {value: 'transfer', text: 'Przelew'},
            ],
        }
    },
    methods: {
        open() {
            this.dialog = true;

            this.prices.price = this.order?.price ?? '';
            this.prices.partnerPrice = this.order?.partnerPrice ?? '';
            this.prices.typeForClient = this.order?.typeForClient ?? '';
            this.prices.paymentType = this.order?.paymentType ?? '';
            this.prices.clientNotes = this.order?.clientNotes ?? '';
            this.prices.undefinedPrice = this.order?.undefinedPrice ?? false;
        },
        async onSubmit() {
            if (!this.$refs.newForm.validate()) {
                return
            }

            api
                .put(`/api/orders/${this.order.id}`, {
                    price: this.prices.undefinedPrice ? null : +this.prices.price.toString().replace(/,/g,'.'),
                    partnerPrice: +this.prices.partnerPrice.toString().replace(/,/g,'.'),
                    typeForClient: this.prices.typeForClient,
                    clientNotes: this.prices.clientNotes,
                    notifyClient: this.prices.notifyClient,
                    paymentType: this.prices.paymentType ?? null,
                    priceForOrder: this.prices.priceForOrder ?? null,
                    undefinedPrice: this.prices.undefinedPrice ?? null
                })
                .then(() => {
                    this.$root.$emit('notifySuccess', {
                        html: 'Uzupełniono ceny.',
                    });
                    this.dialog = false;
                    this.$parent.loadDetails();
                })
                .catch((error) => {
                    console.error('Error when editing a redirect:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd podczas uzupełniania cen',
                    });
                })
        },
    },
}
</script>

<style scoped></style>
